<template>
  <div>
    <div class="card">
      <h1>Télécharger l'application</h1>
      <p>Pour emmener les entrainements que nous proposons partout où tu vas, nous avons créé une application mobile. Pour télécharger cette application sur ton téléphone, rends-toi sur le store d'applications correspondant :</p>
      <div id="contact-container">
        <a class="contact-group" href="">
          <img class="illu-img" src="../assets/android.png" alt="Icone Android">
          <h3>Play-store</h3>
        </a>
        <a class="contact-group"  href="">
          <img class="illu-img"  src="../assets/apple.png" alt="Icone d'Apple">
          <h3>Apple Store</h3>
        </a>
      </div>
    </div>
  </div>
</template>


<style scoped>
  .card {
    width: 70%;
    margin-left: auto;
    margin-right: auto;
  }
  #contact-container {
    margin: 42px 0 10px;
    display: flex;
    justify-content: space-evenly;
  }
  .contact-group {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .illu-img {
    height: 110px;
    margin: 0 0 7px;
  }


  @media screen and (max-width: 1400px) {
    .card {
      width: 85%;
    }
  }
  @media screen and (max-width: 720px) {
    .card {
      width: 96%;
    }
  }
</style>
<script>
export default {
  mounted() {
    window.scrollTo(0, 0)
  }
}
</script>